/**
 * StatusSelector — pill buttons for choosing content status.
 */

import { cn } from '@/utils/cn';
import type { ContentStatus } from '@/types/content.types';

const STATUSES: { value: ContentStatus; label: string; classes: string }[] = [
  {
    value:   'not_started',
    label:   'Not Started',
    classes: 'border-surface-300 text-surface-600 bg-white hover:bg-surface-50 data-[active=true]:border-surface-500 data-[active=true]:bg-surface-100 data-[active=true]:text-surface-900',
  },
  {
    value:   'in_progress',
    label:   'In Progress',
    classes: 'border-amber-300 text-amber-700 bg-white hover:bg-amber-50 data-[active=true]:border-amber-500 data-[active=true]:bg-amber-100',
  },
  {
    value:   'completed',
    label:   'Completed',
    classes: 'border-emerald-300 text-emerald-700 bg-white hover:bg-emerald-50 data-[active=true]:border-emerald-500 data-[active=true]:bg-emerald-100',
  },
  {
    value:   'published',
    label:   'Published',
    classes: 'border-indigo-300 text-indigo-700 bg-white hover:bg-indigo-50 data-[active=true]:border-indigo-500 data-[active=true]:bg-indigo-100',
  },
];

interface StatusSelectorProps {
  value:    ContentStatus;
  onChange: (status: ContentStatus) => void;
  disabled?: boolean;
}

export default function StatusSelector({ value, onChange, disabled }: StatusSelectorProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {STATUSES.map(s => (
        <button
          key={s.value}
          type="button"
          disabled={disabled}
          data-active={value === s.value}
          onClick={() => onChange(s.value)}
          className={cn(
            'px-3 py-1.5 rounded-lg border text-xs font-semibold transition-all',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            s.classes,
          )}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
